import LegalPage from "@/components/legal/LegalPage";
import { legalPolicies } from "@/src/content/legalPolicies";

export default function ListingGuidelinesPage() {
  return <LegalPage policy={legalPolicies.listingGuidelines} />;
}
